import { createAppsList } from 'modules/Apps/listingStore/createAppsList';
import { ListView } from 'modules/Listings/components/ListView/ListView';
import { BreadcrumbJsonLd } from 'next-seo';
import { ENTITY_SLUGS, ListingsStateProvider, useListingStore } from 'modules/Listings/store/StateContext';
import { appsListType } from 'modules/Listings/store/Store.types';
import { withListLayout } from 'modules/Listings/withListLayout';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useMemo } from 'react';
import { buildCommunityBreadcrumbs } from 'utils/breadcrumbs';
import { useQueryClient } from 'react-query';

export const ExploreAppsPage: React.FC<{
  host: string;
}> = ({ host }) => {
  const router = useRouter();
  const query = router.query as Record<string, string>;
  const { userOrOrgId } = query;
  const queryClient = useQueryClient();

  const appsStore = useListingStore<appsListType>(
    useCallback(
      () =>
        createAppsList({
          queryClient,
          userIdFromRouter: userOrOrgId,
          initialQuery: query,
          activeToggle: query?.listFilterType,
        }),
      [userOrOrgId],
    ),
    [userOrOrgId],
  );

  useEffect(() => {
    appsStore.load();
  }, [appsStore]);

  // instantiating inside component so ListingsStateProvider can give state to search, filters etc.
  const ListWithLayout = useMemo(() => withListLayout(ListView, false), []);

  return (
    <ListingsStateProvider store={appsStore} entityType={ENTITY_SLUGS.apps}>
      <BreadcrumbJsonLd itemListElements={buildCommunityBreadcrumbs({ host, page: 'apps' })} />
      <ListWithLayout
        pageName="apps_page"
        title="Browse the variety of AI projects"
        heading="Community Apps contain shared models, LLMs, workflows, and modules to power your ideas."
      />
    </ListingsStateProvider>
  );
};
